var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { DRIVE_DOCUMENTS_ACTIVITY_TYPES } from '@workalizer/shared';
import { diffComparisonType } from '@workalizer/shared/types';
import { calculateAverage, getPercentageDiff, randomInt } from '@workalizer/shared/utils';
var DEMO_TEAM_MEMBER_COUNT = 4;
var buildCountMetric = function (count, previousCount, teamTotal, includeTeamAverage) {
    if (includeTeamAverage === void 0) { includeTeamAverage = false; }
    return (__assign({ count: count, previous: getPercentageDiff(previousCount, count) }, (includeTeamAverage && teamTotal !== undefined
        ? {
            teamAverage: getPercentageDiff(calculateAverage(teamTotal, DEMO_TEAM_MEMBER_COUNT), count, { comparisonType: diffComparisonType.teamAverage })
        }
        : {})));
};
var buildTypeMetrics = function (includeTeamAverage) {
    var created = randomInt(8, 45);
    var edited = randomInt(20, 90);
    var viewed = randomInt(40, 180);
    var sharedLeft = randomInt(15, 60);
    var sharedRight = randomInt(3, 20);
    var commentsLeft = randomInt(8, 40);
    var commentsRight = randomInt(4, 25);
    var suggestionsLeft = randomInt(4, 22);
    var suggestionsRight = randomInt(2, 15);
    return {
        created: buildCountMetric(created, randomInt(10, 50), randomInt(30, 120), includeTeamAverage),
        edited: buildCountMetric(edited, randomInt(25, 95), randomInt(60, 200), includeTeamAverage),
        viewed: buildCountMetric(viewed, randomInt(45, 190), randomInt(120, 400), includeTeamAverage),
        shared: {
            left: buildCountMetric(sharedLeft, randomInt(12, 55), randomInt(40, 150), includeTeamAverage),
            right: buildCountMetric(sharedRight, randomInt(2, 18), randomInt(8, 40), includeTeamAverage)
        },
        comments: {
            left: buildCountMetric(commentsLeft, randomInt(10, 45), randomInt(25, 100), includeTeamAverage),
            right: buildCountMetric(commentsRight, randomInt(5, 28), randomInt(12, 60), includeTeamAverage)
        },
        suggestions: {
            left: buildCountMetric(suggestionsLeft, randomInt(5, 24), randomInt(10, 50), includeTeamAverage),
            right: buildCountMetric(suggestionsRight, randomInt(3, 16), randomInt(6, 30), includeTeamAverage)
        }
    };
};
export var driveDocumentsActivity = function (input) {
    var includeTeamAverage = Boolean(input.userId);
    return DRIVE_DOCUMENTS_ACTIVITY_TYPES.reduce(function (acc, typeKey) {
        acc[typeKey] = buildTypeMetrics(includeTeamAverage);
        return acc;
    }, {});
};
